import React, { useState } from 'react'
import { useChat } from 'hooks/use-chat'
import { useAccount } from 'hooks/use-account';

export const Chat = () => {
  const {messages, sendMessage} = useChat();
  const [message, setMessage] = useState<string>('');
  const { name } = useAccount();

  return (
    <>
      <h4>チャットできるよ</h4>

      <div>
        <div>メッセージ：</div>
        <input value={message} onChange={(e) => { setMessage(e.target.value) }} />
      </div>

      <div>
        <button onClick={() => {
          sendMessage(name, message);
          setMessage('');

        }}>そうしん</button>
      </div>

      <br/>
      <br/>

      <div>
        {messages.map((msg) => (
          <div>{`${msg.name}が「${msg.text}」と言いました`}</div>
        ))}
      </div>
    </>
  )
}

